import { EInvoiceStatus } from '../constants'

const FINAL_FR_EINVOICE_STATUSES = [EInvoiceStatus.Refused, EInvoiceStatus.Approved, EInvoiceStatus.PaymentReceived]

interface FREInvoiceStatusInfo {
  isFinal: boolean
}

export const useFREInvoiceStatusInfo = (status: EInvoiceStatus | null): FREInvoiceStatusInfo | null => {
  if (!status) {
    return null
  }

  return {
    isFinal: FINAL_FR_EINVOICE_STATUSES.includes(status),
  }
}
